import { gql } from '@apollo/client';

export const CREATE_EDITOR_CANVAS_PAGE = gql`
  mutation CreateEditorCanvasPage(
    $fields: CreateEditor_canvas_pagesFieldsInput
  ) {
    createEditor_canvas_pages(input: { fields: $fields }) {
      editor_canvas_pages {
        objectId
      }
    }
  }
`;

export const UPDATE_EDITOR_CANVAS_PAGE = gql`
  mutation UpdateEditorCanvasPage(
    $id: ID!
    $fields: UpdateEditor_canvas_pagesFieldsInput
  ) {
    updateEditor_canvas_pages(input: { id: $id, fields: $fields }) {
      editor_canvas_pages {
        objectId
      }
    }
  }
`;
